import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_CON001_Request,
  IAPI_CON001_Response,
  IAPI_RET011_Request,
  IAPI_RET011_Response,
  IAPI_RET014_Request,
  IAPI_RET014_Response,
  IAPI_RET019_Request,
  IAPI_RET019_Response,
} from "../../../type/apiType";

// 退職者状況一覧参照
const httpAPI_RET011 = async (
  param: IAPI_RET011_Request
): Promise<IAPI_RET011_Response> => {
  let res = await http.post(ApiUrl.API_RET011, {
    ...param,
  });

  return res.data;
};

// 退職者申請メール参照
const httpAPI_RET014 = async (
  param: IAPI_RET014_Request
): Promise<IAPI_RET014_Response> => {
  let res = await http.post(ApiUrl.API_RET014, {
    ...param,
  });

  return res.data;
};

/**
 * 契約者一覧参照API
 * @return httpAPI_CON001
 */
const httpAPI_CON001 = async (
  param: IAPI_CON001_Request
): Promise<IAPI_CON001_Response> => {
  let res = await http.post(ApiUrl.API_CON001, {
    ...param,
  });

  return res.data;
};

/**
 * 退職者検索API
 * @returns httpAPI_RET019
 */
const httpAPI_RET019 = async (
  param: IAPI_RET019_Request
): Promise<IAPI_RET019_Response> => {
  let res = await http.post(ApiUrl.API_RET019, {
    ...param,
  });

  return res.data;
};

export { httpAPI_RET011, httpAPI_RET014, httpAPI_CON001, httpAPI_RET019 };
